// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n.container_box\n{\n   position:relative;\n}\n\n.dashboard_icon\n{\n   position:absolute;\n   top:-35px;\n   left:20px;\n   width:60px;\n   height:60px;\n   border-radius:50%;\n   border:2px solid #5939B6;\n   background-color:white;\n}\n\n.qus_icon\n{\n   margin-left:10px;\n   margin-top:10px;\n   font-size:30px !important;\n}\n", ""]);
// Exports
module.exports = exports;
